export const CLEAR_CURRENT_USER = 'CLEAR_CURRENT_USER';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const GET_CURRENT_USER = 'GET_CURRENT_USER';
export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS';
export const GET_CURRENT_USER_FAIL = 'GET_CURRENT_USER_FAIL';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_REQUEST_FAIL = 'LOGIN_REQUEST_FAIL';
export const LOGIN_REQUEST_SUCCESS = 'LOGIN_REQUEST_SUCCESS';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_REQUEST_SUCCESS = 'LOGOUT_REQUEST_SUCCESS';
export const PASSWORD_RESET = 'PASSWORD_RESET';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_FAIL = 'PASSWORD_RESET_FAIL';
export const FORGOT_PASSWORD_FAIL = 'FORGOT_PASSWORD_FAIL';
export const SET_ERROR_STATUS = 'SET_ERROR_STATUS';
export const SET_SEARCH_PARAM = 'SET_SEARCH_PARAM';
export const SET_SEARCH_PENDING = 'SET_SEARCH_PENDING';
export const SET_SUB_TABLE_QUERY_PENDING = 'SET_SUB_TABLE_QUERY_PENDING';
export const GET_SEARCH_RESULTS = 'GET_SEARCH_RESULTS';
export const GET_CONFIRM_SEARCH_RESULTS = 'GET_CONFIRM_SEARCH_RESULTS';
export const GET_TO_SHIP_SEARCH_RESULTS = 'GET_TO_SHIP_SEARCH_RESULTS';
export const GET_SHIPPED_SEARCH_RESULTS = 'GET_SHIPPED_SEARCH_RESULTS';
export const GET_OPEN_SEARCH_RESULTS = 'GET_OPEN_SEARCH_RESULTS';
export const GET_DELIVERED_SEARCH_RESULTS = 'GET_DELIVERED_SEARCH_RESULTS';
export const GET_RETURNED_SEARCH_RESULTS = 'GET_RETURNED_SEARCH_RESULTS';
export const GET_CANCELED_SEARCH_RESULTS = 'GET_CANCELED_SEARCH_RESULTS';
export const GET_COMPLETED_SEARCH_RESULTS = 'GET_COMPLETED_SEARCH_RESULTS';
export const SET_ACTIVE_LISTINGS = 'SET_ACTIVE_LISTINGS';
export const GET_ACTIVE_LISTINGS = 'GET_ACTIVE_LISTINGS';
export const SET_PRODUCT_VARIANTS = 'SET_PRODUCT_VARIANTS';
export const GET_PRODUCT_VARIANTS = 'GET_PRODUCT_VARIANTS';
export const GET_NEED_TO_CONFIRM_ORDERS = 'GET_NEED_TO_CONFIRM_ORDERS';
export const SET_NEED_TO_CONFIRM_ORDERS = 'SET_NEED_TO_CONFIRM_ORDERS';
export const CONFIRM_ORDER = 'CONFIRM_ORDER';
export const CONFIRM_ORDER_SUCCESS = 'CONFIRM_ORDER_SUCCESS';
export const CONFIRM_ORDER_FAIL = 'CONFIRM_ORDER_FAIL';
export const CANCEL_ORDER = 'CANCEL_ORDER';
export const CANCEL_ORDER_SUCCESS = 'CANCEL_ORDER_SUCCESS';
export const CANCEL_ORDER_FAIL = 'CANCEL_ORDER_FAIL';
export const SET_CURRENT_OPEN_TAB = 'SET_CURRENT_OPEN_TAB';
export const SET_CURRENT_COMPLETED_TAB = 'SET_CURRENT_COMPLETED_TAB';
export const SET_VIEW = 'SET_VIEW';
export const GET_NEED_TO_SHIP_ORDERS = 'GET_NEED_TO_SHIP_ORDERS';
export const SET_NEED_TO_SHIP_ORDERS = 'SET_NEED_TO_SHIP_ORDERS';
export const GET_SHIPPED_ORDERS = 'GET_SHIPPED_ORDERS';
export const SET_SHIPPED_ORDERS = 'SET_SHIPPED_ORDERS';
export const GET_OPEN_ORDERS = 'GET_OPEN_ORDERS';
export const SET_OPEN_ORDERS = 'SET_OPEN_ORDERS';
export const GET_COMPLETED_ORDERS = 'GET_COMPLETED_ORDERS';
export const SET_COMPLETED_ORDERS = 'SET_COMPLETED_ORDERS';
export const GET_DELIVERED_ORDERS = 'GET_DELIVERED_ORDERS';
export const SET_DELIVERED_ORDERS = 'SET_DELIVERED_ORDERS';
export const GET_RETURNED_ORDERS = 'GET_RETURNED_ORDERS';
export const SET_RETURNED_ORDERS = 'SET_RETURNED_ORDERS';
export const GET_CANCELED_ORDERS = 'GET_CANCELED_ORDERS';
export const SET_CANCELED_ORDERS = 'SET_CANCELED_ORDERS';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const SET_CANCEL = 'SET_CANCEL';
export const UPDATE_PRODUCT_PRICE = 'UPDATE_PRODUCT_PRICE';
export const RESET_STORE_PRICE = 'RESET_STORE_PRICE';
export const SET_ACTIVE_LISTINGS_ERROR = 'SET_ACTIVE_LISTINGS_ERROR';
export const CLEAR_ACTIVE_LISTINGS_ERROR = 'CLEAR_ACTIVE_LISTINGS_ERROR';
export const SET_PRODUCT_VARIANTS_ERROR = 'SET_PRODUCT_VARIANTS_ERROR';
export const LABEL_PRINTED = 'LABEL_PRINTED';
export const STATUS_UPDATED_SUCCESS = 'STATUS_UPDATED_SUCCESS';
export const STATUS_UPDATED_FAIL = 'STATUS_UPDATED_FAIL';
